import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import Vant from 'vant'
import 'vant/lib/index.css'
import JSEncrypt from 'jsencrypt'
import qs from 'qs'
import Clipboard from 'clipboard'
import MetaMaskOnboarding from '@metamask/onboarding'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import * as echarts from 'echarts'
import VideoPlayer from 'vue-video-player'
import rsa from './utils/rsa'
import filters from './common/filters'
import i18n from './i18n'

// 添加全局filter
Object.keys(filters).map((v) => {
  Vue.filter(v, filters[v])
})

require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)
Vue.use(ElementUI)
Vue.config.productionTip = false

let Base64 = require('js-base64').Base64
axios.defaults.withCredentials = true
Vue.use(Vant)

const currentUrl = new URL(window.location.href)
const forwarderOrigin = currentUrl.hostname === 'localhost' ? 'http://localhost:9010' : undefined
const onboarding = new MetaMaskOnboarding({ forwarderOrigin })
const { ethereum } = window
const Web3 = require('web3')

Vue.prototype.$publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQChEuUwaHR5OsJ8EM3/8UwJCngMGwufVnAerVGMz6CLg7q9NDn9dUnr83suKZcCHKUpIvzBqJ05vy3zrYGuS1D4cCCIZiZEzN9I1AfllD1fKmcnz1tL56NWZ4HMfhjesAkjxa69Xmh6qYbIFanqHFkqNje+gZ5hDA8Om1/diT/NzwIDAQAB'
Vue.prototype.$rsa = rsa
Vue.prototype.$onboarding = onboarding
Vue.prototype.$web3 = new Web3(ethereum)
Vue.prototype.$ethereum = ethereum
Vue.prototype.Clipboard = Clipboard
Vue.prototype.$axios = axios
Vue.prototype.$jsEncrypt = JSEncrypt
Vue.prototype.qs = qs
Vue.prototype.$envConfig = envConfig
Vue.prototype.$echarts = echarts

new Vue({ router, store, Base64, i18n, render: (h) => h(App) }).$mount('#app')
